import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import {Container, Row, Col} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2Why.module.scss'
const cx = cn.bind(s)

interface IW2WhyProps {
	className?: string
	content: IW2Content['why']
}

/** W2Why block component */
const W2Why: FC<IW2WhyProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<ul className={s.list}>
							{content?.items?.map((item) => (
								<li key={item._key || item.title} className={s.item}>
									<h3 className={cx('itemTitle', 'h3')}>{item.title}</h3>
									<p className={s.itemDescription}>{item.description}</p>
								</li>
							))}
						</ul>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

W2Why.displayName = 'W2Why'

export default W2Why
